import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import '../style.css';

const AdminLogin = () => {
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const navigate = useNavigate();

  const handleSubmit = (e) => {
    e.preventDefault();
    setError('');

    const envUsername = process.env.REACT_APP_ADMIN_USERNAME;
    const envPassword = process.env.REACT_APP_ADMIN_PASSWORD;

    if (username === envUsername && password === envPassword) {
      //  Credentials match – redirect to dashboard
      navigate('/admin/dashboard');
    } else {
      setError('Invalid username or password');
    }
  };

  return (
    <div className="container mt-5" style={{ maxWidth: '500px' }}>
      <h2>Admin Login</h2>
      <form onSubmit={handleSubmit}>
        <label htmlFor="username" className="form-label">
          Username:
        </label>
        <input
          type="text"
          id="username"
          name="username"
          className="form-control"
          value={username}
          onChange={(e) => setUsername(e.target.value)}
          required
        />

        <label htmlFor="password" className="form-label mt-3">
          Password:
        </label>
        <input
          type="password"
          id="password"
          name="password"
          className="form-control"
          value={password}
          onChange={(e) => setPassword(e.target.value)}
          required
        />

        <div className="text-center mt-4">
          <button type="submit" className="btn btn-success">
            Login
          </button>
        </div>

        {error && (
          <div className="alert alert-danger mt-3 text-center">{error}</div>
        )}
      </form>
    </div>
  );
};

export default AdminLogin;
